export default function LogOutIcon({ fillColor = 'var(--color-text-dark)' }) {
    return (
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M11.77 23.37H5.51A4.66 4.66 0 0 1 .85 18.7V5.3A4.66 4.66 0 0 1 5.51.63h6.26a1 1 0 0 1 0 2H5.51A2.66 2.66 0 0 0 2.85 5.3v13.4a2.66 2.66 0 0 0 2.66 2.65h6.26a1 1 0 1 1 0 2Zm5.15-5.14a1 1 0 0 1-.7-1.7l3.53-3.54H7.65a1 1 0 0 1 0-2h12.07l-3.5-3.5a1 1 0 1 1 1.4-1.42l5.2 5.2.05.05a1 1 0 0 1-.02 1.4l-5.22 5.22a1 1 0 0 1-.71.3Z"
                fill={fillColor} />
        </svg>
    )
}